import api from '../callApi';

const apiUrl = 'https://api.geocod.io/v1';
const apiKey = '7fe6aa65a87288cfe6388276ce28a855e8fc855';

function mapFreegeoipResponse(json) {
    if (!json || !json.results || !json.results.length) return null;
    return json.results
        .filter(r => r.fields && r.accuracy > 0.1)
        .map(r => {
            return {
                district: r.fields.congressional_district.district_number,
                state: r.address_components.state,
                postalCode: r.address_components.zip,
                address: {
                    country: r.address_components.country,
                    state: r.address_components.state,
                    city: r.address_components.city,
                    zipCode: r.address_components.zip,
                    street: r.address_components.formatted_street,
                    streetNo: r.address_components.number
                }
            };
        });
}

function getGeocodeUrl(address, latitude, longitude) {
    return !address
        ? `${apiUrl}/reverse?q=${latitude},${longitude}&api_key=${apiKey}&fields=cd`
        : `${apiUrl}/geocode?q=${address}&api_key=${apiKey}&fields=cd`;
}

function getGeocodeData(latitude, longitude, address) {
    const url = getGeocodeUrl(address, latitude, longitude);
    return api.get(url).then(json => {
        let response = null;
        try {
            response = mapFreegeoipResponse(json);
            if (response === null) {
                return Promise.reject('Invalid');
            }
            if (response.forEach(r => r.address.country !== 'US')) {
                return Promise.reject('NotUsBasedError');
            }
        } catch (e) {
            return Promise.reject(e);
        }

        if (response == null) return Promise.reject(json);

        return { addresses: response, isUserInput: address != null };
    });
}

export default getGeocodeData;
